<template>
    <form
        class="search-form"
        action="/"
        role="search"
        @submit.prevent="search"
    >
        <label
            :for="instanceId"
            class="search-form__label"
        >
            {{ label }}
        </label>

        <div class="search-form__field">
            <input
                :id="instanceId"
                v-model="inputModel"
                :autofocus="autofocus"
                :placeholder="placeholder"
                type="search"
                inputmode="search"
                :enterkeyhint="label"
                class="search-form__input"
                @change="search"
            >
            <button
                v-if="inputModel.length > 0"
                type="button"
                class="search-form__button search-form__button--clear button--primary button--icon"
                @click="clearSearch"
            >
                <span class="sr-only">{{ t('search.clear') }}</span>
                <BaseIcon icon="cancel" />
            </button>

            <button
                type="submit"
                class="search-form__button search-form__button--submit button--primary button--icon"
                @click="search"
            >
                <span class="sr-only">{{ t('search.placeholder') }}</span>
                <BaseIcon icon="search" />
            </button>
        </div>
    </form>
</template>

<script setup>
defineProps({
    label: {
        type: String,
        default: '',
        required: true
    },
    placeholder: {
        type: String,
        default: ''
    },
    autofocus: {
        type: Boolean,
        default: false
    }
});

const { t } = useI18n();
const route = useRoute();

const instanceId = useId();
const inputModel = ref(route.query.search ?? '');

const emit = defineEmits(['clear', 'search']);

const clearSearch = () => {
    inputModel.value = '';
    emit('clear');
};

const search = () => {
    emit('search', inputModel.value);
};
</script>

<style lang="less" src="./SearchForm.less" />
